import { render, staticRenderFns } from "./Zoomable.vue?vue&type=template&id=e840e1b2&scoped=true&"
import script from "./Zoomable.vue?vue&type=script&lang=ts&"
export * from "./Zoomable.vue?vue&type=script&lang=ts&"
import style0 from "./Zoomable.vue?vue&type=style&index=0&id=e840e1b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e840e1b2",
  null
  
)

export default component.exports